export default "__VITE_ASSET__sf8GEJAM__"